import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { toIdFormat, capitalizeWords } from '../Utils/stringUtils';
import placeholder from '../../assets/photo-placeholder.png';
import { Skeleton } from '@mui/material';
import './DashboardCard.scss';

export const AlbumCard = React.memo((props) => {
    // Get props and initialize state variables
    const { 
        title, 
        season, 
        sideBarOpen, 
        thumbnailWidth, 
        thumbnailHeight,
        url,
    } = props;
    const [loading, setLoading] = useState(true);
    const [uuid] = useState(() => uuidv4());

    useEffect(() => {
        const image = new Image();
        image.onload = () => setLoading(false);
        image.onerror = () => setLoading(false);
        image.src = url || placeholder;

        return () => {
            image.onload = null;
            image.onerror = null;
        };
    }, [url]);

    return (
        <Link to={`/media/photos/${season}?album=${toIdFormat(title)}`}>
            <div id={`album-card-${uuid}`} className={`album-card ${sideBarOpen ? 'open' : ''}`}>
                <div 
                    id={`album-card-content-${uuid}`} 
                    className="dash-card-content album"
                    style={sideBarOpen ? {marginTop: '-5.5em'} : {}}
                >
                    <h2>{capitalizeWords(title)}</h2>
                    {loading && (
                        <Skeleton 
                            sx={{ margin: '0 auto', borderRadius: '10px'}} 
                            animation="wave" 
                            variant="rectangular"
                            width={thumbnailWidth} 
                            height={thumbnailHeight} 
                        />
                    )}
                    {!loading && (
                        <img 
                            className={`thumbnail${url ? '' : ' holder'}`} 
                            alt={`${toIdFormat(title)}-Thumbnail`} 
                            src={url ? url : placeholder} 
                        />
                    )}
                </div>
            </div>
        </Link>
    );
});
